import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiagramProject, faXmark } from "@fortawesome/free-solid-svg-icons";
import "./CardProject.css"
import CardProjectList from "./CardProjectList";
import ProjectForUserObjectList from "../../../util/ProjectForUserObjectList";
import SrvButton from "../../global/SrvButton";

function CardProject({ idObject, idSelected, update, loading, log }) {
    //onlyRead - Только чтение
    //idSelected - Список выбранных проектов (Массив ID_Project)
    /*
    idObject:
        ID	Name
        1	Задача
        2	Регулярная задача
        3	Доска
        4	Проект
        5	Пользователь
        6	Регулярная задача. Трекер
    */

    const stateProject = useSelector((state) => state.projectList);
    const stateSetting = useSelector((state) => state.setting);

    const [edit, setEdit] = useState(false);

    const [projectsAccess, setProjectsAccess] = useState([]);

    useEffect(() => {
        if (stateProject.listLoaded.filter(a => a.id_status === 1).length > 0
            & stateProject.listObjectLoaded.filter(a => a.id_status === 1).length > 0
            & stateProject.listUserLoaded.filter(a => a.id_status === 1).length > 0
            & idObject != null & stateSetting.user != null & stateSetting.companyService != null) {

            setProjectsAccess(ProjectForUserObjectList(stateProject.list, stateProject.listObject, stateProject.listUser, idObject, stateSetting.user.ID, stateSetting.companyService.ID_Role))
        }
    }, [stateProject.list, stateProject.listObject, stateProject.listUser, stateSetting.companyService, stateSetting.user]);

    //Выбор проекта
    function changeHandler(id, added) {
        update(id, added);
        //setEdit(false);
    }

    return (
        <>
            <div className="form-label"><FontAwesomeIcon icon={faDiagramProject} className="mr-5" />Проекты</div>
            <div className="project_block" onClick={() => setEdit(true)}>
                {idSelected.map(pr => (
                    stateProject.list.filter(a => a.ID === pr.ID_Project).length > 0 &&
                    <div key={pr.ID_Project} className='project_item mr-5' >
                        {stateProject.list.filter(a => a.ID === pr.ID_Project).length > 0 ? stateProject.list.filter(a => a.ID === pr.ID_Project)[0].Name : 'Не найден'}
                    </div>
                ))}
            </div>

            <Modal show={edit} onHide={() => setEdit(false)} >
                <Modal.Body>
                    <div className="modal_close" onClick={() => setEdit(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center">Выбор проектов</div>
                    <div>
                        <CardProjectList id_parent={null} idSelected={idSelected} list={stateProject.list} listAccess={projectsAccess} change={changeHandler} />
                    </div>
                    {loading === true && (
                        <div className="loader_01"></div>
                    )}
                    {log != null && (
                        <div className="form_error text-center mt-15">
                            {log}
                        </div>
                    )}

                    <div className="text-center mt-15">
                        <SrvButton typeBtn="close" size='lg' loading={loading} onClick={() => setEdit(false)} />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CardProject;